import React, { PureComponent } from 'react';

export const OSContext = React.createContext();

const type = navigator?.platform?.toUpperCase()?.indexOf('MAC') >= 0 ? 'mac' : 'default';

const MAP = {
    mac: {
        metaKey: 'Cmd',
        metaKeySymbol: '⌘',

        altKey: 'Alt',
        altKeySymbol: '⌥',

        shiftKey: 'Shift',
        shiftKeySymbol: '⇧'
    },
    default: {
        metaKey: 'Ctrl',
        metaKeySymbol: '',

        altKey: 'Alt',
        altKeySymbol: '',

        shiftKey: 'Shift',
        shiftKeySymbol: '⇧'
    }
}

export class OSProvider extends PureComponent {
    render() {
        return (
            <OSContext.Provider
                value={{
                    keys: MAP[type]
                }}
            >
                { this.props.children }
            </OSContext.Provider>
        );
    }
}
